import React from "react";
import {
  KlipingIndex
} from "../../_metronic/_partials";

export function KlipingPage() {
  return <KlipingIndex />;
}
